import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4400Model } from '../kymw4400.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetPublishGoodsGroupSelectItemsResponse = {
  Code: string;
  Name: string;
}[];

/**
 * 掲載商品グループ選択項目取得サービス
 * @export GetPublishGoodsGroupSelectItemsService
 * @class GetPublishGoodsGroupSelectItemsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPublishGoodsGroupSelectItemsService extends PlessJsonResponderSub<GetPublishGoodsGroupSelectItemsResponse> {
  model: KYMW4400Model;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPublishGoodsGroupSelectItemsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode,
        MediumType: this.model.mediumType,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPublishGoodsGroupSelectItemsService
   */
  execute(
    model: KYMW4400Model,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.succeed = s;
    this.fail = f;
    this.send('getPublishGoodsGroupSelectItems', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPublishGoodsGroupSelectItemsService
   */
  success(data: GetPublishGoodsGroupSelectItemsResponse) {
    this.model.publishGoodsGroupSelectItems = data;
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW4400Model): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    if (status === 'plessError' && result?.errorcode === 'E0100') {
      // E0100許容
      if (this.succeed) this.succeed();
      return;
    }
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
